module.exports = new __parcel__URL__("BaseLogo.e87313d9.svg").toString();